import { useMemo } from 'react';
import { useOpenModal } from '@rainbow-modules/hooks';
import styled from 'styled-components';

const ModalHeader = styled.h1`
    font-size: 22px;
    margin: 16px 24px;
`;

const useBuyPhoneModal = (modalId: string) => {
    const [openModal, closeModal] = useOpenModal(modalId);
    return useMemo(() => ([
        (props: Record<string, unknown> = { title: 'Title' }) => openModal({
            ...props,
            // title needs to be below ...props so that it can't be overridden
            title: <ModalHeader>{props.title as string}</ModalHeader>,
        }),
        closeModal,
    ]), [openModal, closeModal]);
};

export default useBuyPhoneModal;
